var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useOutsideClick } from '../hooks/useOutsideClick';
import { Animation } from '../Animation';
import { DialogElement } from './Dialog.style';
var Dialog = function (_a) {
    var children = _a.children, onClose = _a.onClose, width = _a.width, rounded = _a.rounded, props = __rest(_a, ["children", "onClose", "width", "rounded"]);
    var ref = React.useRef(null);
    useOutsideClick(ref, onClose);
    return (React.createElement(Animation, { key: "drawer", initial: { translateX: '100%' }, animate: { translateX: '0%' }, exit: { translateX: '100%' }, transition: { duration: 0.3 }, style: rounded ? { padding: 16 } : {} },
        React.createElement(DialogElement, __assign({ width: width, ref: ref, rounded: rounded }, props), React.Children.map(children, function (child) {
            var _a;
            if (React.isValidElement(child)) {
                var roundedProp = rounded && ((_a = child.type) === null || _a === void 0 ? void 0 : _a['displayName']) === 'DrawerHeader'
                    ? { rounded: rounded }
                    : {};
                return React.cloneElement(child, __assign({ onClose: onClose }, roundedProp));
            }
            return child;
        }))));
};
export { Dialog };
//# sourceMappingURL=Dialog.js.map